// const productionHost = 'http://localapi.petdata.at:8081';
// const developmentHost = 'http://localapi.petdata.at:8081';
const productionHost = 'https://api.petdata.at';
const developmentHost = 'https://api.petdata.at';
const remoteUrl = process.env.NODE_ENV === 'production' ? productionHost : developmentHost;

export const AUTH_TOKEN = `${remoteUrl}/Token`;
export const CUSTOMER_MYCONTEXT = `${remoteUrl}/api/Customer/MyContext`;

export const CUSTOMER_ALLUSERS = `${remoteUrl}/api/Customer/AllUsers`;
export const REGISTER_USER = `${remoteUrl}/api/Customer/RegisterUser`;
export const UPDATE_USER = `${remoteUrl}/api/Customer/UpdateUserSettings`;

export const CARESHEET_SETTINGS = `${remoteUrl}/api/CareSheet/Settings`;
export const CARESHEET_SETTINGS_AD = `${remoteUrl}/api/CareSheet/Settings/Ad`;
export const CARESHEET_SETTINGS_LOGO = `${remoteUrl}/api/CareSheet/Settings/Logo`;
export const CARESHEET_SETTINGS_INFO = `${remoteUrl}/api/CareSheet/Settings/Info`;
export const CARESHEET_LISTING = `${remoteUrl}/api/CareSheet/CareSheets`;
export const CARESHEET_AS_PDF = `${remoteUrl}/api/CareSheet/CareSheetAsPDF`;

export const LABEL_ALL_PETS = `${remoteUrl}/api/Label/AllPets`;
export const LABEL_DEFINITIONS = `${remoteUrl}/api/Label/LabelDefinitions`;
export const LABEL_PET = `${remoteUrl}/api/Label/Pet`;
export const LABEL_CREATE_AS_JPG = `${remoteUrl}/api/Label/CreateLabelAsJPG`;

export const LABEL_CUSTOM_DEFINITIONS = `${remoteUrl}/api/Label/CustomLabelDefinition`;

export const LABEL_PREPARE_COMPOSITION = `${remoteUrl}/api/Label/PrepareComposition`;
export const LABEL_GET_PDF = `${remoteUrl}/api/Label/LabelPDF`;

export const ARTICLE_UPDATE_MAPPING = `${remoteUrl}/api/Article/UpdateArticleMapping`;
export const ARTICLE_ADD_MAPPING = `${remoteUrl}/api/Article/AddArticleMapping`;
export const ARTICLE_DELETE_MAPPING = `${remoteUrl}/api/Article/RemoveArticleMappings`;

export const ARTICLE_EXCEL_DOWNLOAD = `${remoteUrl}/api/Article/ExportPetArticleMappingsAsExcel`;
export const ARTICLE_EXCEL_UPLOAD = `${remoteUrl}/api/Article/ImportPetArticleMappingsFromExcel`;

export const CUSTOMIZE_LABEL_SETTINGS = `${remoteUrl}/api/Label/LabelSettings`;
export const UPLOAD_LABEL_LOGO = `${remoteUrl}/api/Label/LabelLogo`;

export const CALIBRATION_GET_PDF = `${remoteUrl}/api/Label/CalibrationPDF`;

export const CHANGE_USER_PASSWORD = `${remoteUrl}/api/Customer/ChangePasswordForUser`;

export const CHANGE_PASSWORD = `${remoteUrl}/api/Customer/ChangePassword`;
export const FORGOT_PASSWORD = `${remoteUrl}/api/Customer/ForgotPassword`;

export const SIGNUP_EN = `https://www.petdata.at/`;
export const SIGNUP_DE = `https://www.petdata.at/`;

export const ORDER_MANAGEMENT_LINK = `${remoteUrl}/api/Customer/OrderManagementLink`;


/** WEBPACK FOOTER **
 ** ./src/modules/common/apiEndpoints.js
 **/